import script from "./ReportChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import ReportDateRangeFilter from "@/components/reports/ReportDateRangeFilter.vue";
import TablePagination from "@/components/TablePagination.vue";
script.components = Object.assign({}, { BasicSpinner, ReportDateRangeFilter, TablePagination }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, ReportDateRangeFilter, TablePagination }, script.__o.components);}